/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddAttachmentsRequest as ModelsV3LoanManagementAddAttachmentsRequest } from '../../models/Models/v3/LoanManagement/add-attachments-request';
import { AddAttachmentsResponseBaseResponse as ModelsV3LoanManagementAddAttachmentsResponseBaseResponse } from '../../models/Models/v3/LoanManagement/add-attachments-response-base-response';

export interface V3LoanManagementAttachmentsPost$Xml$Plain$Params {
      body?: ModelsV3LoanManagementAddAttachmentsRequest
}

export function v3LoanManagementAttachmentsPost$Xml$Plain(http: HttpClient, rootUrl: string, params?: V3LoanManagementAttachmentsPost$Xml$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3LoanManagementAddAttachmentsResponseBaseResponse>> {
  const rb = new RequestBuilder(rootUrl, v3LoanManagementAttachmentsPost$Xml$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+xml');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsV3LoanManagementAddAttachmentsResponseBaseResponse>;
    })
  );
}

v3LoanManagementAttachmentsPost$Xml$Plain.PATH = '/v3/loan-management/attachments';
